// Public replay surface matches the reviewed GTM version 20 page allowlist.
export const CLARITY_PUBLIC_PATHS = new Set([
  "/",
  "/local-lessons",
  "/singing-lessons-ely",
  "/singing-lessons-bury-st-edmunds",
  "/about-liuba",
  "/success-stories",
  "/blog",
  "/contact",
  "/cookies",
  "/privacy",
  "/terms",
  "/blog/what-happens-first-singing-lesson-ely",
  "/blog/singing-lessons-near-ely-studio-vs-online",
  "/blog/how-to-choose-singing-teacher-bury-st-edmunds",
  "/blog/how-much-do-singing-lessons-cost-in-ely",
  "/blog/can-adults-learn-to-sing-ely",
  "/blog/two-common-vocal-blockers-pitch-throat-tension",
  "/blog/singing-lessons-near-soham",
  "/blog/singing-lessons-near-newmarket",
  "/blog/singing-lessons-ely-adult-beginners",
  "/blog/liuba-doga-top-singing-tips-for-new-local-students"
]);
